export const IS_NP = false
export const IS_GETENC = true

export const DEBUG_LOCAL_RESPONSE = false;
export const DEBUG_DOWNLOAD_RESPONSE = false;
export const DEBUG_FILTER = false;

// AIS data source configuration
export const AIS_CONFIG = {
    // Использовать ли локальный кэш AIS для обогащения данных флота
    // true - данные AIS будут загружаться из локального кэша /ais/cache/
    // false - использовать только данные с сервера API
    USE_LOCAL_AIS_CACHE: true
};

// Navarea display configuration
export const NAVAREA_CONFIG = {
    // Режим отображения navarea объектов:
    // true - линейные объекты отображаются как отдельные точки (безопасный режим)
    // false - линейные объекты отображаются как полигоны/линии (по умолчанию)
    DISPLAY_POLYGONS_AS_POINTS: true,
    
    // Максимальное количество точек в полигоне, выше которого он будет разбит на отдельные точки
    MAX_POLYGON_POINTS: 20
};


export const CURRENT_PRODUCT = {
    is_navicom: false
};
